import {
  RuleWeightLevelEnum,
  MAX_MODERATE,
  MAX_HIGH,
  MAX_HIGHEST,
} from 'src/components-bl/MerchandisingRules/merchandisingRules.config';
import { SegmentedControlOption } from 'src/components-dummy';
import { MerchandisingRuleTypes } from 'src/services';

export const ACTION_OPTIONS = [
  { value: MerchandisingRuleTypes.RuleAction.Include, text: 'Include' },
  { value: MerchandisingRuleTypes.RuleAction.Exclude, text: 'Exclude' },
  { value: MerchandisingRuleTypes.RuleAction.Promote, text: 'Promote' },
  { value: MerchandisingRuleTypes.RuleAction.Demote, text: 'Demote' },
];

export type PromoteIntensityLevel =
  | RuleWeightLevelEnum.Moderate
  | RuleWeightLevelEnum.High
  | RuleWeightLevelEnum.Highest;

export const INTENSITY_WEIGHT_BY_LEVEL: Record<PromoteIntensityLevel, number> = {
  [RuleWeightLevelEnum.Moderate]: MAX_MODERATE,
  [RuleWeightLevelEnum.High]: MAX_HIGH,
  [RuleWeightLevelEnum.Highest]: MAX_HIGHEST,
};

export const INTENSITY_OPTIONS: SegmentedControlOption<PromoteIntensityLevel>[] = [
  { value: RuleWeightLevelEnum.Moderate, label: 'Moderate' },
  { value: RuleWeightLevelEnum.High, label: 'High' },
  { value: RuleWeightLevelEnum.Highest, label: 'Highest' },
];

export const getIntensityLevelFromWeight = (weight: number): PromoteIntensityLevel => {
  if (weight <= MAX_MODERATE) return RuleWeightLevelEnum.Moderate;
  if (weight <= MAX_HIGH) return RuleWeightLevelEnum.High;
  return RuleWeightLevelEnum.Highest;
};
